import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';
declare function ire(string,{}): any;
@Component({
  selector: 'app-word-plugin',
  templateUrl: './word-plugin.component.html',
  styleUrls: ['./word-plugin.component.scss']
})
export class wordpluginComponent implements OnInit, AfterViewInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService
  ) { }


  ngOnInit() {
    this.titleService.setTitle('Microsoft Word용 트랑카 플러그인을 다운로드하세요 | 무료 문법 검사 프로그램');
    this.metaTagService.updateTag({ name: 'description', content: 'Word에 트랑카를 플러그인하면 전보다 쉽고 효율적인 글쓰기를 할 수 있습니다! 친숙한 Word 문서에서 글을 쓰면 트랑카가 자동 검사합니다. 지금 무료로 Trinka를 다운로드하세요!' });
    this.metaTagService.updateTag({ name: 'keywords', content: '트링카, Trinka, 고급 문법 검사, 철자 검사기, 무료 문법 검사, 학술적 글쓰기 지원, 문법체크, 논문문법검사, 기술문서문법검사' });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Microsoft Word용 트랑카 플러그인을 다운로드하세요 | 무료 문법 검사 프로그램' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Word에 트랑카를 플러그인하면 전보다 쉽고 효율적인 글쓰기를 할 수 있습니다! 친숙한 Word 문서에서 글을 쓰면 트랑카가 자동 검사합니다. 지금 무료로 Trinka를 다운로드하세요!' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/kr/wordplugin' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/word-add-in-banner.svg' });
    this.metaTagService.updateTag({ name: 'language', content: 'ko-kr' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: "Microsoft Word용 트랑카 플러그인을 다운로드하세요 | 무료 문법 검사 프로그램" });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Word에 트랑카를 플러그인하면 전보다 쉽고 효율적인 글쓰기를 할 수 있습니다! 친숙한 Word 문서에서 글을 쓰면 트랑카가 자동 검사합니다. 지금 무료로 Trinka를 다운로드하세요!" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/word-add-in-banner.svg' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/kr/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/wordplugin' });
    if (isPlatformBrowser(this.platformId)) {
      // $.getScript('../../../assets/js/particles.min.js', function () { });
      $.getScript('../../../assets/js/about_us_testimonial_silders.js', function () { });
      if (navigator.userAgent.indexOf("WOW64") != -1 ||
        navigator.userAgent.indexOf("Win64") != -1) {
        document.getElementById("windowInfo64bit").innerHTML = '<a  style="color:#FFF" href="https://s3.amazonaws.com/trinka-word-plugin/64bit/Trinka.Installer.msi" target="_blank"><img src="../../../assets/images/whitePaper_download.png" alt="" style="width: 26px; margin: -6.5px 10px 0 0;"> 지금 다운로드</a>';
      } else {
        document.getElementById("windowInfo64bit").innerHTML = '<a style="color:#FFF" href="https://s3.amazonaws.com/trinka-word-plugin/32bit/Trinka.Installer.msi" target="_blank"><img src="../../../assets/images/whitePaper_download.png" alt="" style="width: 26px; margin: -6.5px 10px 0 0;"> 지금 다운로드</a>';
      }
    }
    
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      $.getScript('../../../assets/js/home_client_slider.js', function () { });
      $.getScript('../../../assets/js/about_us_testimonial_silders.js', function () { });
      $('#closedPopup, #wordPluginPopup').click(function () {
        $('iframe.youtubeVideoForTryDemo').remove()
      });

      $('#VewiVideoSection').click(function () {
        if (!$('#iframe').length) {
          $('#iframeHolder').html('<iframe class="youtubeVideoForTryDemo" id="iframe" src="https://www.youtube.com/embed/8dmdUUvVj3Q" width="100%" height="450"></iframe>');
        }
      });

    }
  }

  generateGuid() {
    var result, i, j;
    result = '';
    for(j=0; j<32; j++) {
      if( j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random()*16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }
}
